export default (palette) => ({
  root: {
    color: palette.icon, // Agora com suporte 100% dinâmico ao Switch de Tema! 🛡️🌓🚀
    minWidth: 32,
  },
})
